import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListFiscContratos from '../../components/contratos/fiscais'


function FiscaisScreen() {
    return (
        <Fragment>
            <Head titulo="Lista de Servidores Municipais Fiscais de Contratos de Licitação" />
            <Header />
            <Container>
               <ListFiscContratos />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default FiscaisScreen;